/** Token storage helpers for access + refresh JWT lifecycle. */

export const USER_STORAGE_KEY = 'user'

export function readStoredAuth(storage = globalThis.localStorage) {
  try {
    const raw = storage?.getItem?.(USER_STORAGE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    return parsed
  } catch {
    return null
  }
}

export function writeStoredAuth(data, storage = globalThis.localStorage) {
  if (!data?.access_token) {
    storage?.removeItem?.(USER_STORAGE_KEY)
    return null
  }
  const prev = readStoredAuth(storage) || {}
  const payload = {
    access_token: data.access_token,
    // Keep previous refresh if response omitted it (defensive).
    refresh_token:
      data.refresh_token != null && data.refresh_token !== ''
        ? data.refresh_token
        : prev.refresh_token || null,
    token_type: data.token_type || prev.token_type || 'bearer',
    expires_in: data.expires_in ?? prev.expires_in ?? null,
  }
  storage?.setItem?.(USER_STORAGE_KEY, JSON.stringify(payload))
  return payload
}

export function clearStoredAuth(storage = globalThis.localStorage) {
  storage?.removeItem?.(USER_STORAGE_KEY)
}

export function getAccessToken(storage = globalThis.localStorage) {
  return readStoredAuth(storage)?.access_token || null
}

export function getRefreshToken(storage = globalThis.localStorage) {
  return readStoredAuth(storage)?.refresh_token || null
}

const IMPERSONATION_KEY = 'impersonation'

function readSessionStorage() {
  try {
    return globalThis.sessionStorage || null
  } catch {
    return null
  }
}

/** Вкладка имперсонализации: per-tab сессия цели в sessionStorage. */
export function isImpersonationTab() {
  const storage = readSessionStorage()
  if (!storage) return false
  try {
    return JSON.parse(storage.getItem(IMPERSONATION_KEY))?.active === true
  } catch {
    return false
  }
}

/** Завершить сессию имперсонализации (не трогает токен админа в localStorage). */
export function clearImpersonationSession() {
  const storage = readSessionStorage()
  if (!storage) return
  try {
    storage.removeItem(USER_STORAGE_KEY)
    storage.removeItem(IMPERSONATION_KEY)
  } catch {
    // ignore
  }
}
